import { useEffect } from 'react';
import { useLocation, useNavigation } from 'react-router-dom';
import { SESSION_STORAGE_KEYS } from '@/common/constants/storage';

export function useSafePendingUrl() {
  const location = useLocation();
  const navigation = useNavigation();

  useEffect(() => {
    if (navigation.location) {
      const url =
        navigation.location.pathname +
        navigation.location.search +
        navigation.location.hash;
      sessionStorage.setItem(SESSION_STORAGE_KEYS.PENDING_URL, url);
    }
  }, [navigation.location, location]);
}
